export enum ServiceRequestCode {
  PathologyRequest = 'servicerequest.pathology.request',
}

export const ServiceRequestCodeDescription: Record<ServiceRequestCode, string> =
  {
    [ServiceRequestCode.PathologyRequest]: 'Pathology Request',
  };

// TODO this should be moved to the generic identifiers list
export enum ServiceRequestPerformerIdentifier {
  Ampath = 'servicerequest.performer.ampath',
  Lancet = 'servicerequest.performer.lancet',
}

// TODO this should be moved to the generic identifiers list
export enum ServiceRequestIdentifier {
  AmpathOrderNumber = 'servicerequest.identifier.ampath.ordernumber',
  LancetOrderNumber = 'servicerequest.identifier.lancet.ordernumber',
  LancetOrderId = 'servicerequest.identifier.lancet.orderid',
}

export const ServiceRequestPerformerDescription: Record<
  ServiceRequestPerformerIdentifier,
  string
> = {
  [ServiceRequestPerformerIdentifier.Ampath]: 'Ampath',
  [ServiceRequestPerformerIdentifier.Lancet]: 'Lancet',
};

export enum ServiceRequestType {
  escalationRequest = 'servicerequest.careplan.escalation',
}
